import { DEFAULT_PRECISION_KM, DEFAULT_RADIUS_KM } from "@/modules/jobAds/client/constants"

export const getAlgoliaLatLngParams = (
  lat: string | null,
  lng: string | null,
  radius: number | undefined
): { aroundLatLng?: string; aroundPrecision?: number; aroundRadius?: number } => {
  if (!lat || !lng) return {}

  return {
    aroundLatLng: `${lat}, ${lng}`,
    aroundPrecision: DEFAULT_PRECISION_KM * 1000,
    aroundRadius: (radius || DEFAULT_RADIUS_KM) * 1000,
  }
}
